import React from 'react';
import { CircularProgress, Typography } from '@mui/material';
import Box from '@mui/material/Box';

// ==============================|| AUTH LOADER ||============================== //

const AuthLoader = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        flexDirection: 'column',
        gap: 2,
        backgroundColor: '#f8f9fa'
      }}
    >
      <CircularProgress size={60} color="primary" />
      <Typography
        variant="h6"
        color="text.secondary"
        sx={{ fontWeight: 500, textAlign: 'center' }}
      >
        Checking access...
      </Typography>
      <Typography
        variant="body2"
        color="text.disabled"
        sx={{ maxWidth: 300, textAlign: 'center' }}
      >
        Please wait while we verify your authentication status
      </Typography>
    </Box>
  );
};

export default AuthLoader;
